import { InitGA } from '@bnnvara/analytics';
import { useBrand } from '@bnnvara/brand';
import flow from 'lodash/flow';
import has from 'lodash/has';
import getConfig from 'next/config';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import useUI, {
  TYPE_CLOSE_MENU,
  TYPE_CLOSE_SEARCH,
  TYPE_OPEN_SEARCH,
} from '../../hooks/useUI';
import Hub from '../Hub';
import Menu from '../Menu';
import Overlay from '../overlay/Overlay';
import SearchPage from '../search/SearchPage';

const Topbar = ({ router }) => {
  const {
    state: { menuOpen, searchOpen },
    dispatch,
  } = useUI();
  const brand = useBrand();

  const { publicRuntimeConfig } = getConfig();

  const closeSearch = () => dispatch({ type: TYPE_CLOSE_SEARCH });
  const closeMenu = () => dispatch({ type: TYPE_CLOSE_MENU });
  const closeOverlay = flow([closeSearch, closeMenu]);

  useEffect(() => {
    const openSearch = () => dispatch({ type: TYPE_OPEN_SEARCH });

    const { query } = router;

    if (has(query, 'query')) {
      openSearch();
    }
  }, [dispatch, router]);

  const open = menuOpen || searchOpen;

  return (
    <React.Fragment>
      <InitGA id={publicRuntimeConfig.googleAnalytics.id} />
      <Hub />
      <Overlay open={open} onRequestClose={closeOverlay}>
        {menuOpen && <Menu open={menuOpen} />}
        {searchOpen && <SearchPage brand={brand} />}
      </Overlay>
    </React.Fragment>
  );
};

Topbar.propTypes = {
  router: PropTypes.shape({
    query: PropTypes.shape({
      query: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(Topbar);
